import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice } from 'utils/index';

type ListNumberProps = {
  number: number;
};

const ListNumber: React.FC<ListNumberProps> = ({ number }) => {
  const twoDigitNumber = number.toString().padStart(2, '0');

  return (
    <View style={styles.container}>
      <Text
        style={[
          styles.numberText,
          {
            width: calcSizeForDevice(70),
            fontSize: calcSizeForDevice(48),
            lineHeight: calcSizeForDevice(52),
            marginRight: calcSizeForDevice(32),
          },
        ]}>
        {twoDigitNumber}
      </Text>
      <View style={styles.verticalLine} />
    </View>
  );
};

export default ListNumber;

const styles = StyleSheet.create({
  container: {
    height: calcSizeForDevice(60),
    alignItems: 'center',
    flexDirection: 'row',
  },
  numberText: {
    color: 'white',
    fontFamily: theme.fonts.inter.bold,
  },
  verticalLine: {
    width: 10,
    backgroundColor: '#7A8CFF',
    height: '100%',
  },
});
